import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { Bert } from 'meteor/themeteorchef:bert';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty } from 'lodash';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Connectors from '../../../api/Connectors/Connectors';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import { renderTextField } from '../../components/MaterialMUIComponent';

const MapsAdvancedPointMapField = props => {
  const {
    settingsAdvanced,
    serverConnection,
    setSettingsAdvanced,
    listComponentsAdvanced,
    setListComponentsAdvanced
  } = props;
  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.pointMap);
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.PointMapComponent.name
  );
  const [allSources, setAllSources] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [newSourceModal, setNewSourceModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.PointMapComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.PointMapComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.PointMapComponent.libraryIcon
  );

  const streetViewOptions = [
    { name: 'View inside the app', value: 'inside' },
    { name: 'window', value: 'View in new window' }
  ];

  const [selectedSource, setSelectedSource] = React.useState('');
  const [alias, setAlias] = React.useState('');
  const [imageUrl, setImageUrl] = React.useState('');

  const handleModalToggle = () => {
    setNewSourceModal(!newSourceModal);
    if (newSourceModal) {
      setSelectedSource('');
      setAlias('');
      setImageUrl('');
    }
  };

  const handleAddToTable = () => {
    if (!selectedSource || !alias || !imageUrl) {
      Bert.alert('Por favor, completa todos los campos antes de añadir', 'info');
      return;
    }

    const sourceObject = allSources.find(item => item.name === selectedSource);

    if (!sourceObject) {
      Bert.alert('Fuente seleccionada no válida.', 'error');
      return;
    }

    const newEntry = {
      ...sourceObject,
      alias,
      image: imageUrl,
      disc: localSettings.disc.trim()
    };

    setLocalSettings(prev => {
      const updatedSource = [...prev.source, newEntry];
      setSettingsAdvanced(prevAdvanced => ({
        ...prevAdvanced,
        pointMap: {
          ...prevAdvanced.pointMap,
          source: updatedSource // Sincronizar con el nuevo array
        }
      }));

      return {
        ...prev,
        source: updatedSource
      };
    });

    handleModalToggle();
  };

  const handleDelete = index => {
    setLocalSettings(prevSettings => {
      const updatedSource = prevSettings.source.filter((_, i) => i !== index);

      setSettingsAdvanced(prevAdvanced => {
        const updatedPointMapSource = prevAdvanced.pointMap.source.filter((_, i) => i !== index);
        return {
          ...prevAdvanced,
          pointMap: {
            ...prevAdvanced.pointMap,
            source: updatedPointMapSource
          }
        };
      });

      return {
        ...prevSettings,
        source: updatedSource
      };
    });
  };

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        PointMapComponent: {
          name: listComponentsAdvanced.PointMapComponent.name,
          show: listComponentsAdvanced.PointMapComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        PointMapComponent: {
          name: listComponentsAdvanced.PointMapComponent.name,
          show: listComponentsAdvanced.PointMapComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const callToBack = async serverProp => {
    const urlFunction = () => {
      let url;
      if (serverProp.serverType === 'IGP') {
        url = `http://${serverProp.ip}:${serverProp.port}/MG/lidar/write_lidar_html`;
      } else if (serverProp.serverType === 'IGPS' || serverProp.serverType === 'input') {
        url = `${serverProp.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };
    const response = await fetch(urlFunction(), {
      method: 'POST',
      body: JSON.stringify({
        ftpIp: '',
        ftpPort: '',
        ftpUser: '',
        ftpPassword: '',
        httpPort: '',
        disc: localSettings.disc.trim(),
        projectName: 'Request',
        projectPath: '',
        projectsEntwine: '',
        position: ''
      }),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();
    setAllSources(respuesta);
  };

  // const handleToggle = item => {
  //   const currentIndex = localSettings.source.findIndex(el => el.name === item.name);
  //   const newChecked = [...localSettings.source];
  //   if (currentIndex === -1) {
  //     newChecked.push({
  //       name: item.name,
  //       path: item.path,
  //       image: 'https://sd1.d3.ipsilum.com/files_uploaded/lidar.png'
  //     });
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }

  //   setLocalSettings({ ...localSettings, source: newChecked });
  //   setSettingsAdvanced(prev => ({
  //     ...prev,
  //     pointMap: {
  //       ...prev.pointMap,
  //       source: newChecked
  //     }
  //   }));
  // };

  React.useEffect(() => {
    if (!isEmpty(settingsAdvanced.pointMap.server)) {
      callToBack(settingsAdvanced.pointMap.server);
    }
  }, []);

  return (
    <Box display="flex" width="100%" gab={1} justifyContent="space-around">
      <Box display="column" width="40%" gab={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <TravelExploreIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() => {
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                PointMapComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.PointMapComponent.show
                }
              });
            }}
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={iconFontawesome}
            startLibrary={libraryIcon}
            svg={iconSvg}
            startCategorySvg={listComponentsAdvanced.PointMapComponent.cetegorySvg}
          />
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true">
          {renderTextField({
            label: 'Disc',
            key: 'disc',
            moreProps: {
              fullWidth: true,
              value: localSettings.disc,
              onChange: event => {
                setSettingsAdvanced(prev => ({
                  ...prev,
                  pointMap: {
                    ...prev.pointMap,
                    disc: event.target.value
                  }
                }));
                setLocalSettings({
                  ...localSettings,
                  disc: event.target.value
                });
              }
            }
          })}
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Conexión IPS"
            size="small"
            value={localSettings.server.name}
            onChange={event => {
              const serverSelectedSearch = serverConnection.find(
                element => element.name === event.target.value
              );
              callToBack(serverSelectedSearch);
              setSettingsAdvanced(prev => ({
                ...prev,
                pointMap: {
                  ...prev.pointMap,
                  server: serverSelectedSearch
                }
              }));
              setLocalSettings({
                ...localSettings,
                server: serverSelectedSearch
              });
            }}
          >
            {serverConnection.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Street View Type</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Street View Type"
            size="small"
            value={localSettings.streetViewType}
            onChange={event => {
              setSettingsAdvanced(prev => ({
                ...prev,
                pointMap: {
                  ...prev.pointMap,
                  streetViewType: event.target.value
                }
              }));
              setLocalSettings({
                ...localSettings,
                streetViewType: event.target.value
              });
            }}
          >
            {streetViewOptions.map(item => (
              <MenuItem key={item.value} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <Box display="column" width="75%" spacing={1}>
          <Typography>Sources</Typography>
          <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
            <List>
              {allSources.map(item => (
                <ListItem key={item.name} button onClick={() => handleToggle(item)}>
                  <Checkbox
                    edge="start"
                    checked={localSettings.source.findIndex(el => el.name === item.name) !== -1}
                    tabIndex={-1}
                    disableRipple
                    sx={{
                      color: '#2A3F90',
                      '&.Mui-checked': {
                        color: '#2A3F90'
                      }
                    }}
                  />
                  <ListItemText primary={item.name} secondary={item.path} />
                </ListItem>
              ))}
            </List>
          </div>
        </Box> */}
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleModalToggle}
          sx={{ marginBottom: 2 }}
        >
          Add Source
        </Button>
        <Box display="column" width="75%" spacing={1} margin="auto">
          <TableContainer style={{ maxHeight: '50vh', overflow: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Alias</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {localSettings.source.map((row, index) => (
                  <TableRow key={uuid()}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.alias}</TableCell>
                    <TableCell>
                      <img
                        src={row.image}
                        alt={row.alias}
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton color="error" onClick={() => handleDelete(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <Modal
        open={newSourceModal}
        onClose={handleModalToggle}
        aria-labelledby="add-source-modal"
        aria-describedby="add-source-form"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4
          }}
        >
          <Typography id="add-source-modal" variant="h6" gutterBottom>
            Add Source
          </Typography>
          <Box display="flex" gap={2} flexDirection="column">
            <FormControl fullWidth>
              <InputLabel>Source</InputLabel>
              <Select
                value={selectedSource}
                onChange={e => setSelectedSource(e.target.value)}
                label="Source"
                size="small"
              >
                {allSources.map(source => (
                  <MenuItem key={source.name} value={source.name}>
                    {source.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Alias"
              value={alias}
              onChange={e => setAlias(e.target.value)}
              variant="outlined"
              size="small"
            />

            <TextField
              label="Image URL"
              value={imageUrl}
              onChange={e => setImageUrl(e.target.value)}
              variant="outlined"
              size="small"
            />

            <Button variant="contained" color="primary" onClick={handleAddToTable} fullWidth>
              Add
            </Button>
          </Box>
        </Box>
      </Modal>
      <Box display="column" width="40%" gab={1} />
    </Box>
  );
};

export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !connectionsSub.ready() && !connectorsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGP', 'IGPS'] } }).fetch(),
    connectors: Connectors.find({ deleted: { $eq: 'no' }, type: 'PostgreSQL' }).fetch()
  };
})(MapsAdvancedPointMapField);
MapsAdvancedPointMapField.defaultProps = {};
MapsAdvancedPointMapField.propTypes = {
  serverConnection: PropTypes.array.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired
};
